// extracted by mini-css-extract-plugin
export default {"btn":"Keyboard_btn__JodeR","active":"Keyboard_active__VU+Tc","inactive":"Keyboard_inactive__qwhxZ"};